export default "__VITE_ASSET__VRAku6fjghkApIISiBWPzg__"